export const actionTypes = {
    COLLECT_RAW_DATA_LEGACY: 'operationalParameters_v2/COLLECT_RAW_DATA_LEGACY',
    COLLECT_RAW_DATA: 'operationalParameters_v2/COLLECT_RAW_DATA',
    CLEAR_COLLECT_RAW_DATA_ERROR: 'operationalParameters_v2/CLEAR_COLLECT_RAW_DATA_ERROR',
};
